import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import Icon from './IconBase/Icon';

export default ({
  children,
  label,
  className = '',
  transitionDuration = '0.2s',
  initiallyOpen,
  onStateChange,
}) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen || false);

  useEffect(() => {
    if (onStateChange) onStateChange(isOpen);
  }, [isOpen]);

  return (
    <div className={'collapsible ' + className}>
      <label onClick={() => setIsOpen(!isOpen)}>
        {label}
        <Icon iconCode={isOpen ? 'expand_less' : 'expand_more'} />
      </label>
      <div className="collapsible__content">
        <Collapse isOpened={isOpen}>{children}</Collapse>
      </div>
    </div>
  );
};
